import React from "react";
import { VariantPickerSharedProperties } from "../utils";
import { FONTS, fontSize } from "../../../../../styles/fonts";
import { css } from "@emotion/react";
import { betweenMediaQuery, CSS_MQ } from "../../../../../styles/breakpoints";
import { labelWithNewAttributeClassName } from "../../../../../components/_shared-components/new/new-label";
import { CSS_COLORS } from "../../../../../styles/styles-css-variables";
import cn from "classnames";
import { useGeneralTranslationsContext } from "../../../../../global/hooks/use-general-translations-context";
import { InternalLinkOrButtonForPickers } from "./InternalLinkOrButtonForPickers";
import { NewLabel2 } from "../../../NewLabel2";

export const VariantButtonView: React.FC<{
  name: string;
  isNew: boolean;
  target: VariantPickerSharedProperties["target"];
  state: VariantPickerSharedProperties["state"];
  gridLess: boolean;
  className: string;
}> = props => {
  const Content = (
    <span css={[FONTS.SwarovskiFutura500, fontSize.x2]}>
      <NewLabel2 name={props.name} isNew={props.isNew} />
    </span>
  );

  const className = cn(
    {
      "no-grid": props.gridLess,
    },
    props.className,
  );

  return (
    <InternalLinkOrButtonForPickers action={props.target} attachStyles={styles} className={className}>
      {Content}
    </InternalLinkOrButtonForPickers>
  );
};

const styles = css`
  &.no-grid {
    display: flex;
  }

  &:not(.no-grid) {
    display: grid;

    grid-template-columns: 11fr 5fr;
    grid-column-gap: 20px;

    ${betweenMediaQuery(768, 1200)} {
      grid-template-columns: 1fr;
      grid-template-rows: auto auto;
      grid-row-gap: 4px;
    }
  }

  align-items: center;

  padding: 4px 16px 3px;
  min-height: 36px;
  ${CSS_MQ.atLeastMd} {
    padding: 5px 20px 4px;
    min-height: 46px;
  }

  background-color: ${CSS_COLORS.White};
  color: ${CSS_COLORS.Green};

  border-radius: 8px;
  border: 1px solid ${CSS_COLORS.Green};

  text-decoration: none;

  .active > & {
    background-color: ${CSS_COLORS.Green};
    color: ${CSS_COLORS.White};
  }

  .disabled > & {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
  }
`;
